<template>
  <span class="fancy-button bg-gradient1" @click="onClick">
    <span style="pointer-events: none;">
      <slot/>
      <i class="material-icons-outlined">{{icon}}</i>
      {{label}}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    label: { type: String },
    icon: { type: String },
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  },
  name: "BasicButton"
}
</script>

<style scoped>

.bg-gradient1 span,
.bg-gradient1:before {
  background: #e74a23;
  background: linear-gradient(to right, #e74a23 0%, #efa118 80%, #ffe140 100%);
  /*border: 0.5vh solid white;*/
  /*box-shadow: 0 -1px 0 #e74a23, 0 1px 0 #e74a23, 1px 0 0 #e74a23, -1px 0 0 #e74a23;*/
}
/* fancy Button */
.fancy-button {
  display: inline-block;
  margin: 30px;
  /*font-family: "Montserrat", Helvetica, Arial, sans-serif;*/
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 2vh;
  font-weight: 500;
  letter-spacing: 0.03em;
  /*text-transform: uppercase;*/
  color: #ffffff;
  position: relative;
}
.fancy-button:before {
  content: "";
  display: inline-block;
  height: 40px;
  position: absolute;
  bottom: -5px;
  left: 30px;
  right: 30px;
  z-index: -1;
  border-radius: 30em;
  filter: blur(20px) brightness(0.95);
  transform-style: preserve-3d;
  transition: all 0.3s ease-out;
}
.fancy-button span {
  display: inline-block;
  padding: 18px 60px;
  border-radius: 50em;
  position: relative;
  will-change: transform, filter;
  transform-style: preserve-3d;
  transition: all 0.3s ease-out;
}
.fancy-button:focus, .fancy-button:active {
  color: #ffffff;
}
.fancy-button:hover {
  color: #ffffff;
}
.fancy-button:hover span {
  filter: brightness(1.05) contrast(1.05);
  transform: scale(0.95);
}
.fancy-button:hover:before {
  bottom: 0;
  filter: blur(10px) brightness(0.95);
}
.fancy-button.pop-onhover:before {
  opacity: 0;
  bottom: 10px;
}
.fancy-button.pop-onhover:hover:before {
  bottom: -7px;
  opacity: 1;
  filter: blur(20px);
}
.fancy-button.pop-onhover:hover span {
  transform: scale(1.04);
}
.fancy-button.pop-onhover:hover:active span {
  filter: brightness(1) contrast(1);
  transform: scale(1);
  transition: all 0.15s ease-out;
}
.fancy-button.pop-onhover:hover:active:before {
  bottom: 0;
  filter: blur(10px) brightness(0.95);
  transition: all 0.2s ease-out;
}

.fancy-button .material-icons-outlined {
  vertical-align: middle;
  display: inline;
  font-family: 'Material Icons';
  font-size: 3.5vh;
  line-height: 1;

  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BasicButton.vue